import Component from "@tunnel-components/@pages/supervision/inhibitions/home/component";
import * as React from "react";
import { connect } from "react-redux";
import * as Utils from "@Cyclope-Utils/index";
import * as Lodash from "lodash";
import {
  IncidentInhibateLocalLoadedActionCreator,
  IncidentInhibateLocalRemoveActionCreator,
  InhibitionByCameraLoadedActionCreator,
} from "@tunnel-store/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onOpenInhibitionModal
 * @name onInhibitionRemove
 * @name onClickOnglet
 * @name
 * @name componentDidUpdate
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { boolean }      state.errorserver
     * @property { boolean }      state.loading
     * @property { boolean }      state.btnloading
     * @property { boolean }      state.inhibition
     * @property { boolean }      state.noIncidents
     * @property { boolean[] }    state.ongletActive
     */
    this.state = {
      btnloading: false,
      errorserver: false,
      inhibition: false,
      loading: false,
      noIncidents: false,
      noInhibitionCameras: false,
      ongletActive: [true, false, false, false],
      ongletActiveCameras: [true, false, false, false],
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onOpenInhibitionModal = this.onOpenInhibitionModal.bind(this);
    this.onInhibitionRemove = this.onInhibitionRemove.bind(this);
    this.onClickOnglet = this.onClickOnglet.bind(this);
    this.onClickOngletCameras = this.onClickOngletCameras.bind(this);
    this.onCloseInhibitionModal = this.onCloseInhibitionModal.bind(this);
  }
  /**
   * Changement des état des onglets
   * @public
   * @method onClickOnglet
   * @param { string } param
   * @param { number } index
   * @infos "https://reactjs.org"   (param: string ,index: number) => (event : any): void
   */
  public onClickOnglet = (param: string, index: number) => (
    event: any
  ): void => {
    /**
     * @constant
     * @name ongletActive
     * @type any[]
     */
    const ongletActive: any[] = [];
    {
      /** comparaison */
    }
    for (let i = 1; i <= Math.ceil(this.state.ongletActive.length); i++) {
      ongletActive.push(false);
    }

    ongletActive[index] = true;

    // localStorage.setItem("ongletActive", param);

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ ongletActive }));
  };
  /**
   * Changement des état des onglets
   * @public
   * @method onClickOngletCameras
   * @param { string } param
   * @param { number } index
   * @infos "https://reactjs.org"   (param: string ,index: number) => (event : any): void
   */
  public onClickOngletCameras = (param: string, index: number) => (
    event: any
  ): void => {
    /**
     * @constant
     * @name ongletActiveCameras
     * @type any[]
     */
    const ongletActiveCameras: any[] = [];
    {
      /** comparaison */
    }
    for (
      let i = 1;
      i <= Math.ceil(this.state.ongletActiveCameras.length);
      i++
    ) {
      ongletActiveCameras.push(false);
    }

    ongletActiveCameras[index] = true;

    // localStorage.setItem("ongletActiveCameras", param);

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ ongletActiveCameras }));
  };

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ loading: true });
    // Utils.onCloseInhibition();
    const columnsKey: any = localStorage.getItem("columns");

    this.setState({ columnsKey });

    this.props
      .IncidentInhibateLocalLoadedActionCreator()
      .then(() => {
        if (!Lodash.isUndefined(this.props.error)) {
          this.setState((state: any): any => ({ errorserver: true }));
        }
      })
      .then(() => {
        if (
          !Lodash.isUndefined(this.props.data) &&
          Lodash.isEmpty(this.props.data) &&
          Lodash.isUndefined(this.props.error)
        ) {
          this.setState((state: any): any => ({
            errorserver: false,
            noIncidents: true,
            ongletActive: [true, false, false, false],
          }));
        }
      })
      .then(() => {
        if (!Lodash.isUndefined(this.props.data)) {
          this.setState((state: any): any => ({
            errorserver: false,
            noIncidents: false,
            noInhibitionCameras: false,
          }));
        }
      })
      .then(() => this.setState((state: any): any => ({ loading: false })));

    this.props.InhibitionByCameraLoadedActionCreator(); // inhibition par camera
  }
  /**
   * Ouverture du modal pour créer des inhibitions
   * @public
   * @method onOpenInhibitionModal
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onOpenInhibitionModal = (event: any) => {
    // Utils.onOpenInhibition();
    this.setState((state: any): any => ({
      inhibition: !this.state.inhibition,
    }));
  };
  /**
   * Ouverture du modal pour créer des inhibitions
   * @public
   * @method onCloseInhibitionModal
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onCloseInhibitionModal = (event: any) => {
    // Utils.onOpenInhibition();
    this.setState((state: any): any => ({ inhibition: false }));
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      errorserver: false,
      noIncidents: false,
      noInhibitionCameras: false,
      inhibition: false,
    }));
    localStorage.removeItem("ongletActive");
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        this.setState((state: any): any => ({ errorserver: true }));
      }
      {
        /** Comparaison */
      }
    } else if (nextProps.data !== this.props.data) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (
        !Lodash.isUndefined(nextProps.data) &&
        Lodash.isUndefined(this.props.error) &&
        Lodash.isEmpty(nextProps.data)
      ) {
        this.setState({
          errorserver: false,
          noIncidents: true,
          ongletActive: [true, false, false, false],
        });
      } else if (!Lodash.isUndefined(nextProps.data)) {
        this.setState((state: any): any => ({
          errorserver: false,
          noIncidents: false,
        }));
        this.setState((state: any): any => ({ inhibition: false }));
      }
    } else if (nextProps.dataCameraInhibit !== this.props.dataCameraInhibit) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.dataCameraInhibit)) {
        if (Lodash.isEmpty(nextProps.dataCameraInhibit)) {
          this.setState((state: any): any => ({ noInhibitionCameras: true }));
        } else {
          this.setState((state: any): any => ({
            allcamera: nextProps.dataCameraInhibit,
            noInhibitionCameras: false,
          }));
        }
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison des props */
    }
    if (prevState.columnsKey !== this.state.columnsKey) {
      Utils.persistentColumnPosition();
    }
  }
  /**
   * Supprimer une inhibition
   * @public
   * @method onInhibitionRemove
   * @param { any } event
   * @param { number } param
   * @infos "https://reactjs.org"
   */
  public onInhibitionRemove = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ btnloading: true }));
    this.props
      .IncidentInhibateLocalRemoveActionCreator(param)
      .then(() =>
        this.props
          .IncidentInhibateLocalLoadedActionCreator()
          .then(() =>
            this.setState((state: any): any => ({ btnloading: false }))
          )
      );
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    Utils.persistentColumnPosition();
    return (
      <Component
        onClickOngletCameras={this.onClickOngletCameras}
        onClickOnglet={this.onClickOnglet}
        onCloseInhibitionModal={this.onCloseInhibitionModal}
        onOpenInhibitionModal={this.onOpenInhibitionModal}
        onInhibitionRemove={this.onInhibitionRemove}
        {...this.props}
        {...this.state}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    data: state.IncidentInhibateLocalLoaded.data,
    error: state.IncidentInhibateLocalLoaded.error,
    dataCameraInhibit: state.InhibitionByCameraLoaded.data,
    // loading : state.IncidentInhibateLocalLoaded.loading
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  IncidentInhibateLocalLoadedActionCreator,
  IncidentInhibateLocalRemoveActionCreator,
  InhibitionByCameraLoadedActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/inhibitions/home/container.tsx